<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 527.4 205.8"
    style="enable-background:new 0 0 527.4 205.8;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #db0f16;
        }
    </style>
    <g>
        <path
            d="M34.2,205.5h-5.8l-6.6-21.6l-6.6,21.6H9.5L0,169.9h7.2l5.5,22.5l6.5-22.5h5.2l6.5,22.5l5.6-22.5h7.2L34.2,205.5z"
        />
        <path d="M61.8,176.1v29.4h-7v-29.4h-9.3v-6.2h25.6v6.2H61.8z" />
        <path
            d="M97.7,201.7c-2.9,3.1-6.2,4-10.1,4c-4,0-7-1.3-9.5-3.8c-3.6-3.5-3.6-7.6-3.6-14.4c0-6.8,0-10.8,3.6-14.4
		c2.5-2.4,5.5-3.8,9.5-3.8c8.3,0,12.5,5.4,13.4,11.4h-7c-0.8-3.4-2.8-5.2-6.4-5.2c-1.9,0-3.4,0.8-4.4,1.9c-1.3,1.5-1.7,3.2-1.7,10
		c0,6.8,0.4,8.5,1.7,10.1c1,1.1,2.5,1.8,4.4,1.8c2.2,0,3.9-0.8,5-2c1.2-1.3,1.6-2.9,1.6-4.8v-1.3h-6.6v-5.8h13.5v5.2
		C101.1,196,100.3,199,97.7,201.7z"
        />
        <path d="M119.8,205.5v-35.6h7v29.4h16.2v6.2H119.8z" />
        <path
            d="M153.2,194.5c0,3.4,2,5.8,5.7,5.8c2.8,0,4.2-0.9,5.9-2.5l4,3.9c-2.7,2.7-5.2,4.1-9.9,4.1c-6.2,0-12.1-2.8-12.1-13.4
		c0-8.5,4.6-13.3,11.3-13.3c7.2,0,11.4,5.2,11.4,12.6v2.8H153.2z M162.4,187.2c-0.7-1.5-2.1-2.7-4.3-2.7c-2.2,0-3.7,1.2-4.3,2.7
		c-0.5,1-0.6,1.7-0.6,2.8h9.9C163,188.9,162.9,188.2,162.4,187.2z"
        />
        <path
            d="M175.3,175v-5.3h6.7v5.3H175.3z M175.4,205.5v-25.3h6.5v25.3H175.4z"
        />
        <path
            d="M197.3,205.5c-5.3,0-7.6-3.8-7.6-7.5v-12.9H187v-5h2.8v-7.7h6.5v7.7h4.6v5h-4.6v12.5c0,1.5,0.7,2.4,2.2,2.4h2.3v5.5H197.3z
		"
        />
        <path
            d="M215.1,205.8c-4.1,0-7.8-0.5-11.1-3.8l4.2-4.2c2.1,2.1,5,2.5,7,2.5c2.2,0,4.6-0.8,4.6-2.7c0-1.3-0.7-2.2-2.8-2.4l-4.2-0.4
		c-4.6-0.4-7.5-2.5-7.5-7.3c0-5.5,4.8-8.3,10.1-8.3c4.1,0,7.5,0.8,10,3l-4,4.1c-1.5-1.4-3.8-1.8-6.1-1.8c-2.6,0-3.7,1.2-3.7,2.5
		c0,1.3,0.8,2,2.7,2.2l4.1,0.4c5.2,0.5,7.8,3.2,7.8,7.7C226.1,203,221.2,205.8,215.1,205.8z"
        />
        <path
            d="M239.2,205.5c-5.3,0-7.6-3.8-7.6-7.5v-12.9h-2.8v-5h2.8v-7.7h6.5v7.7h4.6v5h-4.6v12.5c0,1.5,0.7,2.4,2.2,2.4h2.3v5.5H239.2
		z"
        />
        <path
            d="M253.5,194.5c0,3.4,2,5.8,5.7,5.8c2.8,0,4.2-0.9,5.9-2.5l3.9,3.9c-2.7,2.7-5.2,4.1-9.9,4.1c-6.2,0-12.1-2.8-12.1-13.4
		c0-8.5,4.6-13.3,11.4-13.3c7.2,0,11.3,5.2,11.3,12.6v2.8H253.5z M262.8,187.2c-0.7-1.5-2.2-2.7-4.3-2.7c-2.2,0-3.7,1.2-4.4,2.7
		c-0.4,1-0.5,1.7-0.6,2.8h9.9C263.4,188.9,263.3,188.2,262.8,187.2z"
        />
        <path
            d="M283.2,205.5c-5.4,0-7.6-3.8-7.6-7.5v-28.2h6.5v27.8c0,1.5,0.7,2.4,2.3,2.4h2.5v5.5H283.2z"
        />
        <path
            d="M299.4,205.5c-5.4,0-7.6-3.8-7.6-7.5v-28.2h6.5v27.8c0,1.5,0.7,2.4,2.3,2.4h2.5v5.5H299.4z"
        />
        <path
            d="M312.9,194.5c0,3.4,2,5.8,5.7,5.8c2.8,0,4.2-0.9,5.9-2.5l4,3.9c-2.7,2.7-5.2,4.1-9.9,4.1c-6.2,0-12.1-2.8-12.1-13.4
		c0-8.5,4.6-13.3,11.3-13.3c7.2,0,11.4,5.2,11.4,12.6v2.8H312.9z M322.2,187.2c-0.7-1.5-2.1-2.7-4.3-2.7c-2.2,0-3.7,1.2-4.3,2.7
		c-0.5,1-0.6,1.7-0.6,2.8h9.9C322.8,188.9,322.7,188.2,322.2,187.2z"
        />
        <path
            d="M350.4,205.5v-15.8c0-3.5-2.2-4.8-4.3-4.8c-2,0-4.3,1.2-4.3,4.8v15.8h-6.5v-26.1h6.3v2.4c1.7-1.8,4.1-2.7,6.5-2.7
		c2.6,0,4.7,0.8,6.2,2.3c2.1,2.1,2.7,4.6,2.7,7.4v16.7H350.4z"
        />
        <path
            d="M372,205.5c-5.3,0-7.6-3.8-7.6-7.5v-12.9h-2.8v-5h2.8v-7.7h6.5v7.7h4.6v5H371v12.5c0,1.5,0.7,2.4,2.2,2.4h2.3v5.5H372z"
        />
        <path
            d="M386.3,194.5c0,3.4,2,5.8,5.7,5.8c2.8,0,4.2-0.9,5.9-2.5l4,3.9c-2.7,2.7-5.2,4.1-9.9,4.1c-6.2,0-12.1-2.8-12.1-13.4
		c0-8.5,4.6-13.3,11.3-13.3c7.2,0,11.4,5.2,11.4,12.6v2.8H386.3z M395.6,187.2c-0.7-1.5-2.1-2.7-4.3-2.7c-2.2,0-3.7,1.2-4.3,2.7
		c-0.5,1-0.6,1.7-0.6,2.8h9.9C396.2,188.9,396.1,188.2,395.6,187.2z"
        />
        <path
            d="M419,205.8c-5.2,0-11.7-2.8-11.7-13.4c0-10.6,6.5-13.3,11.7-13.3c3.6,0,6.3,1.1,8.6,3.5l-4.4,4.4c-1.4-1.5-2.5-2-4.2-2
		c-1.5,0-2.8,0.5-3.7,1.7c-1,1.2-1.5,3-1.5,5.8s0.5,4.5,1.5,5.8c0.9,1.1,2.2,1.7,3.7,1.7c1.7,0,2.8-0.6,4.2-2l4.4,4.4
		C425.3,204.6,422.6,205.8,419,205.8z"
        />
        <path
            d="M447.8,205.5v-15.8c0-3.5-2.2-4.8-4.3-4.8c-2,0-4.3,1.2-4.3,4.8v15.8h-6.5v-35.6h6.5v12c1.7-1.8,3.8-2.7,6.3-2.7
		c2.6,0,4.7,0.8,6.2,2.3c2.1,2.1,2.7,4.6,2.7,7.4v16.7H447.8z"
        />
        <path
            d="M476.4,205.5v-15.8c0-3.5-2.2-4.8-4.3-4.8c-2.1,0-4.4,1.2-4.4,4.8v15.8h-6.5v-26.1h6.4v2.4c1.7-1.8,4.1-2.7,6.5-2.7
		c2.6,0,4.7,0.8,6.2,2.3c2.1,2.1,2.7,4.6,2.7,7.4v16.7H476.4z"
        />
        <path
            d="M489.8,175v-5.3h6.7v5.3H489.8z M489.9,205.5v-25.3h6.5v25.3H489.9z"
        />
        <path
            d="M519.3,205.5l-6.4-10.9l-2.8,3.1v7.8h-6.5v-35.6h6.5v20.2l8.7-10.7h7.9l-9.3,10.5l10,15.6H519.3z"
        />
    </g>
    <g>
        <polygon
            class="st0"
            points="226.4,62.9 226.4,70.1 259,70.1 259,109.8 266.2,109.8 266.2,70.1 298.7,70.1 298.7,62.9 	"
        />
        <path
            class="st0"
            d="M282.4,83.9h16.3l0-5.1c0-1.1-0.9-2-2-2h-21.9c-1.1,0-2,0.9-2,2v29c0,1.1,0.9,2,2,2h21.9c1.1,0,2-0.9,2-2V92.1
		c0-1.1-0.9-2-2-2l-9.6,0v6.1h4.4v3.2c0,3.1-0.2,3.3-3.2,3.3h-5.1c-3.2,0-3.5-0.8-3.5-3.2V86.3C279.7,84.3,280.2,83.9,282.4,83.9z"
        />
        <polygon
            class="st0"
            points="245.3,97.6 239.5,88 233.6,97.6 233.6,76.7 226.4,76.7 226.4,109.8 233.7,109.8 239.5,100.4 
		245.2,109.8 252.5,109.8 252.5,76.7 245.3,76.7 	"
        />
        <path
            class="st0"
            d="M262.6,0L149.3,128.6h226.6L262.6,0z M262.6,13.8l93.1,105.7H169.4L262.6,13.8z"
        />
    </g>
</svg>
